export var optional = function (rule) {
    return function (value, values, texts) {
        if (!value) {
            return '';
        }
        return rule(value, values, texts);
    };
};
//# sourceMappingURL=optional.js.map